import axios from 'axios';

import { API_URL } from '../constants/api';

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  responseType: 'json',
});

let activeApiRequests = 0;

const finishTrackedRequest = (config) => {
  if (!config?.tracksApiActivity) return;

  activeApiRequests = Math.max(0, activeApiRequests - 1);
};

axiosInstance.interceptors.request.use((config) => {
  if (!config.skipApiActivityTracking) {
    activeApiRequests += 1;
    return { ...config, tracksApiActivity: true };
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    finishTrackedRequest(response.config);
    return response;
  },
  (error) => {
    finishTrackedRequest(error.config);
    return Promise.reject(error);
  }
);

export const hasActiveApiRequests = () => activeApiRequests > 0;

export default axiosInstance;
